import script from "./successbox.vue?vue&type=script&setup=true&lang=js"
export * from "./successbox.vue?vue&type=script&setup=true&lang=js"

import "./successbox.vue?vue&type=style&index=0&id=78ab945c&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ab945c"]])

export default __exports__